module.exports = __webpack_public_path__ + "static/media/bell-buoy1.e27f3fa0.aac";